import React, { useState, createContext, useEffect } from 'react'
import { toast } from 'react-toastify'

export const ToastContext = createContext()

export const ToastProvider = props => {
   const [toasts, setToasts] = useState({ type: 'error', messages: [] })

   useEffect(() => {
      toasts.messages?.map(toasted => {
         let position = toast.POSITION.BOTTOM_RIGHT
         let autoClose = 3000

         switch (toasts.type) {
            case 'error':
               toast.error(toasted.msg, { position, autoClose })
               break
            case 'info':
               toast.info(toasted.msg, { position, autoClose })
               break
            case 'success':
               toast.success(toasted.msg, { position, autoClose })
               break
            case 'warn':
               toast.warn(toasted.msg, { position, autoClose })
               break
            default:
               toast(toasted.msg, { position, autoClose })
               break
         }

         return null
      })
   }, [toasts])

   return <ToastContext.Provider value={{ setToasts }}>{props.children}</ToastContext.Provider>
}
